import { useEffect, useState } from 'react'
import * as API from '@/services/api.js'
import { handleError } from '@/services/errorHandler.js'
import { useDashboardContext } from '@/context-state/DashboardContext.jsx'
import { IntegrationProviders } from '@/consts/index.js'
import { toast } from 'sonner'
import { CircleLoader } from '@/components/loader/CircleLoader.jsx'
import { getCreativeById } from '@/services/api.js'

const defaultImage = 'https://miro.com/app/images/application/icons/board_vis_230905/board_icon_22.png?etag=20230906'

export const CreativeVideoPreview = ({ creative }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [videoSource, setVideoSource] = useState(creative.source ?? '')
    const { integrationsContext, creativeContext } = useDashboardContext()
    const { integrations } = integrationsContext
    const { updateCreativeStateById } = creativeContext

    const metaIntegration = integrations.find(integration => integration.provider === IntegrationProviders.META)

    // TODO - might need to move it away...
    const getVideoSource = async () => {
        try {
            setIsLoading(true)

            if (!creative) {
                return
            }

            if (creative?.source) {
                setVideoSource(creative.source)
                return
            }

            // Try to get source from the backend, since the job might be done with the transfer
            const creativeResponse = await getCreativeById(creative._id)
            if (creativeResponse?.data?.source) {
                setVideoSource(creativeResponse.data.source)
                updateCreativeStateById(creative._id, creativeResponse.data)
                return
            }

            // This is here for a backup in case the user will want to see the video and the source is not available yet.
            if (creative?.permalinkUrl) {
                const relativeLink = creative.permalinkUrl.startsWith('/') ? creative.permalinkUrl.replace('/', '') : creative.permalinkUrl
                const url = `https://facebook.com/${relativeLink}`
                const { data } = await API.getMetaVideo(url)
                if (data?.links?.['Download High Quality']) {
                    const videoLink = data.links['Download High Quality']
                    const updateCreativeResponse = await API.updateCreative(creative._id, { source: videoLink, transferred: false })
                    setVideoSource(videoLink)
                    updateCreativeStateById(creative?._id, updateCreativeResponse.data)
                }
            }

        } catch (e) {
            console.error(e)
            handleError(e)
            toast.error(e.message)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (creative.type === 'video' && creative.origin === 'Meta' &&  creative.videoId && !creative.source && metaIntegration) {
            getVideoSource()
        }
    }, [])


    return (
        <div className="relative max-h-[520px] overflow-hidden">
            {
                isLoading && (
                    <div className="absolute top-0 left-0 z-50 bg-background/50 h-full w-full flex items-center justify-center">
                        <CircleLoader />
                    </div>
                )
            }
            {
                videoSource
                    ? <video controls className="w-full h-[520px] m-auto" src={videoSource}/>
                    : <img src={creative.imageUrl ? creative.imageUrl : defaultImage} className="rounded-lg w-full h-full object-contain m-auto" alt=""/>
            }
        </div>
    )
}